import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {UntypedFormControl, ValidatorFn} from '@angular/forms';

@Directive({
    selector: '[ngcUrlPrefix]'
})
export class UrlPrefixDirective {
    @Input('ngcUrlPrefix') urlPrefix = 'https';
    @Input() urlFormControl: UntypedFormControl;
    @Input() ngcUrlValidator: ValidatorFn;

    constructor(private elementRef: ElementRef
    ) {}

    @HostListener('blur', ['$event.target.value'])
    onKeyUp(value) {
        value = value.trim();
        if (value
            && !/^(https?):\/\//i.test(value)
            && value.indexOf('http://') !== 0
            && value.indexOf('https://') !== 0 ) {
            value = this.urlPrefix + '://' + value;
        }

        if (this.urlFormControl) {
            if (this.ngcUrlValidator && !this.urlFormControl.hasValidator(this.ngcUrlValidator)) {
                this.urlFormControl.addValidators(this.ngcUrlValidator);
            }

            this.urlFormControl.setValue(value);
            this.urlFormControl.updateValueAndValidity();
        }
        return this.elementRef.nativeElement.value = value;
    }
}
